// ColorTabs.js
import React from "react";
import { Table } from "react-bootstrap";

const colorData = [
  {
    product: "Gildan 3000 Unisex Adult Shirt",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Heather Midnigh Navy",
      "Black",
      "Navy",
      "Light Pink",
      "Red",
      "White",
      "Maroon",
      "Millitary Green",
      "Sand",
      "True Royal",
    ],
  },
  {
    product: "Gildan 5000 Unisex Adult Shirt",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Black",
      "Navy",
      "Red",
      "White",
      "Sand",
      "True Royal",
    ],
  },
  {
    product: "Bella Canvas 3001/3001CVC or Gildan 64000",
    colors: [
      "Sport Athletic Heather",
      "Forest Green",
      "Dark Grey Heather",
      "Heather Mauve",
      "Heather Maroon",
      "Heather Midnigh Navy",
      "Black",
      "Dark Grey",
      "Navy",
      "Light Pink",
      "Red",
      "White",
      "Maroon",
      "Heather Deep Teal",
      "Kelly Green",
      "Natural",
      "Heather Grass Green",
      "Millitary Green",
      "True Royal",
      "Heather Military Green",
    ],
  },
  {
    product: "T-shirt- Women Bella Canvas 6400/6400CVC",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Heather Mauve",
      "Heather Midnigh Navy",
      "Black",
      "Dark Grey",
      "Navy",
      "Pink",
      "Red",
      "White",
      "Maroon",
      "Natural",
      "Millitary Green",
    ],
  },
  {
    product: "Bella Canvas or Gildan Unisex Youth Shirt",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Heather Mauve",
      "Heather Maroon",
      "Heather Midnigh Navy",
      "Black",
      "Dark Grey",
      "Navy",
      "Pink",
      "Red",
      "White",
      "Maroon",
      "Heather Deep Teal",
      "Kelly Green",
      "Heather Grass Green",
      "Millitary Green",
      "True Royal",
    ],
  },
  {
    product: "Baby One Piece",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Black",
      "Navy",
      "Pink",
      "Red",
      "White",
      "True Royal",
    ],
  },
  {
    product: "Toddler T-Shirt",
    colors: [
      "Sport Athletic Heather",
      "Dark Grey Heather",
      "Heather Mauve",
      "Heather Maroon",
      "Black",
      "Navy",
      "Pink",
      "Red",
      "White",
      "Kelly Green",
      "True Royal",
    ],
  },
  {
    product: "Next Level or Bella Canvas Racerback",
    colors: [
      "Sport Athletic Heather",
      "Heather Mauve",
      "Black",
      "Dark Grey",
      "Navy",
      "Pink",
      "Red",
      "White",
      "Kelly Green",
      "Raspberry",
      "True Royal",
    ],
  },
  {
    product: "Next Level or Bella Canvas Women V neck",
    colors: [
      "Sport Athletic Heather",
      "Heather Mauve",
      "Black",
      "Dark Grey",
      "Navy",
      "Pink",
      "Red",
      "White",
      "Kelly Green",
      "Heather Grass Green",
      "Raspberry",
      "True Royal",
    ],
  },
  {
    product: "Gildan 18500 Hoodies",
    colors: [
      "Sport Athletic Heather",
      "Forest Green",
      "Dark Grey Heather",
      "Black",
      "Navy",
      "Light Pink",
      "Red",
      "White",
      "Maroon",
      "Millitary Green",
      "Sand",
    ],
  },
  {
    product: "Gildan 18000 Sweatshirt",
    colors: [
      "Sport Athletic Heather",
      "Forest Green",
      "Dark Grey Heather",
      "Black",
      "Navy",
      "Light Pink",
      "Red",
      "White",
      "Maroon",
      "Millitary Green",
      "Sand",
      "Dark Chocolate",
    ],
  },
  {
    product: "Gildan Youth 18000B Sweatshirt",
    colors: [
      "Sport Athletic Heather",
      "Forest Green",
      "Dark Grey Heather",
      "Black",
      "Navy",
      "Light Pink",
      "Red",
      "White",
      "Maroon",
      "True Royal",
    ],
  },
  {
    product: "Unisex Adult Comfort Colors 1717",
    colors: [
      "Blue Jean",
      "Orchid",
      "Yam",
      "Pepper",
      "Moss",
      "Mustard",
      "Black",
      "Blossom",
      "Blue Spruce",
      "Brick",
      "Chambray",
      "Ivory",
      "Light Green",
      "Sage",
      "Sandstone",
      "Terracotta",
      "Violet",
      "Watermelon",
      "White",
      "Red",
      "Gray",
      "Espresso",
    ],
  },
  {
    product: "Bella Canvas Crop Tank",
    colors: [
      "Sport Athletic Heather",
      "Forest Green",
      "Dark Grey Heather",
      "Heather Mauve",
      "Heather Maroon",
      "Heather Midnigh Navy",
      "Black",
      "Dark Grey",
      "Navy",
      "Light Pink",
      "Pink",
      "Red",
      "White",
      "Maroon",
      "Heather Deep Teal",
      "Kelly Green",
      "Natural",
    ],
  },
];

const allColors = Array.from(
  new Set(colorData.flatMap((p) => p.colors))
).sort();

const ColorTabs = () => {
  const normalData = colorData.filter(
    (item) => item.product !== "Unisex Adult Comfort Colors 1717"
  );
  const comfortColorsData = colorData.find(
    (item) => item.product === "Unisex Adult Comfort Colors 1717"
  );

  const allColors = Array.from(
    new Set(normalData.flatMap((p) => p.colors))
  ).sort();
  const comfortColors = comfortColorsData
    ? comfortColorsData.colors.sort()
    : [];

const renderTable = (data, colors, isSticky = true) => (
  <div
    style={{
      overflowX: "auto",
      overflowY: isSticky ? "auto" : "unset",
      maxHeight: isSticky ? "80vh" : "unset",
      marginBottom: "40px",
      position: "relative", // sticky için şart
    }}
  >
    <Table
      bordered
      hover
     
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <thead>
        <tr>
          <th
            style={{
              position: isSticky ? "sticky" : "static",
              top: isSticky ? 0 : "unset",
              left: 0,
              zIndex: isSticky ? 3 : "auto",
              backgroundColor: "#fff",
              fontSize: "12px",
              fontWeight: "bold",
              textAlign: "center",
              minWidth: "300px",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            Product
          </th>
          {colors.map((color) => (
            <th
              key={color}
              style={{
                position: isSticky ? "sticky" : "static",
                top: isSticky ? 0 : "unset",
                zIndex: isSticky ? 2 : "auto",
                fontSize: "11px",
                fontWeight: "bold",
                textAlign: "center",
                verticalAlign: "middle",
                backgroundColor: "#f9f9f9",
                borderBottom: "2px solid #ccc",
                minWidth: "100px",
                whiteSpace: "normal",
              }}
            >
              {color}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
          <td
  style={{
    fontWeight: "bold",
    position: "sticky",
    left: 0,
    backgroundColor: "#f1f1f1",
    zIndex: 1,
    minWidth: "150px",      // ✅ Daha dar
    maxWidth: "180px",      // ✅ Limitli genişlik
    fontSize: "11px",       // ✅ Daha küçük font
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.2",      // ✅ Satırlar dar
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,     // ✅ En fazla 2 satır
    WebkitBoxOrient: "vertical",
  }}
>
  {row.product}
</td>

            {colors.map((color) => (
            <td
  key={color}
  style={{
    backgroundColor: row.colors.includes(color)
      ? "#d6f5d6"
      : "#fff",
    textAlign: "center",
    fontSize: "11px",           // ✅ Küçük font
    padding: "4px",             // ✅ Dar padding
    maxWidth: "80px",           // ✅ Sabit genişlik
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }}
>
  {row.colors.includes(color) ? "YES" : ""}
</td>

            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);




return (
  <>
    {renderTable(normalData, allColors, true)}  
    {comfortColorsData && renderTable([comfortColorsData], comfortColors, false)}  
  </>
);

};

export default ColorTabs;
